import Vue from 'vue'
import Vuex from 'vuex'
import Services from "./helpers/common.services"

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    // constant states
    BEFORE:'before',
    AFTER:'after',
    // active state
    activeState:'before',
    // results
    refundResults:{
      simulationType:null,
      totalSpentAmount:null,
      socialSecurityRefundAmount:null,
      complementaryRefundAmount:null,
      leftToPayAmount:null,
      informationMessages:[],
    },
    complexRefundResults:null,
    // errors
    errors:[],
    running:false
  },
  getters:{
    showResults: state => state.activeState == state.AFTER,
    appRunning: state => state.running
  },
  mutations: {
    setState(state, to){
      state.activeState = to
    },
    setResults(state, data){
      // Data mapping and consistency check
      if(data.simulationType) {
        state.refundResults.simulationType = data.simulationType
      }

      if(data.totalSpentAmount) {
        state.refundResults.totalSpentAmount = parseFloat(data.totalSpentAmount).toFixed(2).replace('.',',');
      }
      
      if(data.refundSimpleData) {
        state.refundResults.socialSecurityRefundAmount = parseFloat(data.refundSimpleData.socialSecurityRefundAmount).toFixed(2).replace('.',',');
        state.refundResults.complementaryRefundAmount = parseFloat(data.refundSimpleData.complementaryRefundAmount).toFixed(2).replace('.',',');
        state.refundResults.leftToPayAmount = parseFloat(data.refundSimpleData.leftToPayAmount).toFixed(2).replace('.',',');
      }

      if(data.refundComplexData) {
        state.complexRefundResults = data.refundComplexData;
        state.complexRefundResults.forEach(
          element => 
          {
            element.socialSecurityRefundAmount = parseFloat(element.socialSecurityRefundAmount).toFixed(2).replace('.',','),
            element.complementaryRefundAmount = parseFloat(element.complementaryRefundAmount).toFixed(2).replace('.',','),
            element.leftToPayAmount = parseFloat(element.leftToPayAmount).toFixed(2).replace('.',',')
          }
        )
      }

      data.informationMessages.forEach(element => state.refundResults.informationMessages.push(element))
    },
    resetResults(state){
      state.refundResults.socialSecurityRefundAmount = null
      state.refundResults.complementaryRefundAmount = null
      state.refundResults.leftToPayAmount = null
      state.refundResults.totalSpentAmount = null
      state.complexRefundResults = null
      state.refundResults.informationMessages = []
    },
    pushError(state, error){
      state.errors.push(error)
    },
    clearErrors(state){
      state.errors = []
    },
    setRunning(state, status){
      state.running = status
    }
  },
  actions:{
    simulateRefund({ commit }, { simulationType, specificData }){
      commit('setRunning', true)
      Services.Calculate(simulationType, specificData, commit)
    },
    backToSimulation({ commit }){
      commit('setState', 'before')
      commit('resetResults')
    },
    clearErrors({ commit }){
      commit('clearErrors')
    }
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store.js